import "./widget.scss";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import Skeleton from "@mui/material/Skeleton";

const Widget = ({ type, title, value, icon }) => {
  let data;
  const amount = 100;

  // Handle Super Admin widgets
  if (title && value !== undefined) {
    data = {
      title,
      value,
      icon
    };
  }
  // Handle regular widgets
  else {
    switch (type) {
      case "user":
        data = {
          title: "USERS",
          icon: (
            <PersonOutlinedIcon
              className="icon"
              style={{
                color: "crimson",
                backgroundColor: "rgba(255, 0, 0, 0.2)",
              }}
            />
          ),
        };
        break;
      case "categories":
        data = {
          title: "CATEGORIES",
          icon: (
            <ShoppingCartOutlinedIcon
              className="icon"
              style={{
                backgroundColor: "rgba(218, 165, 32, 0.2)",
                color: "goldenrod",
              }}
            />
          ),
        };
        break;
      case "quiz":
        data = {
          title: "QUIZES",
          icon: (
            <MonetizationOnOutlinedIcon
              className="icon"
              style={{ backgroundColor: "rgba(0, 128, 0, 0.2)", color: "green" }}
            />
          ),
        };
        break;
      case "question":
        data = {
          title: "QUESTIONS",
          icon: (
            <AccountBalanceWalletOutlinedIcon
              className="icon"
              style={{
                backgroundColor: "rgba(128, 0, 128, 0.2)",
                color: "purple",
              }}
            />
          ),
        };
        break;
      default:
        data = { title: "", value: 0, icon: null };
    }
  }

  return (
    <div className="widget">
      <div className="left">
        <span className="title">{data.title}</span>
        <span className="counter">
          {data.value !== undefined ? data.value : amount}
        </span>
      </div>
      <div className="right">
        {data.icon || (
          <div className="icon-placeholder super-admin-icon" />
        )}
      </div>
    </div>
  );
};

// Skeleton component for loading state
Widget.Skeleton = () => (
  <div className="widget">
    <div className="left">
      <Skeleton variant="text" width={80} height={24} />
      <Skeleton variant="text" width={60} height={32} />
    </div>
    <div className="right">
      <Skeleton variant="circular" width={40} height={40} />
    </div>
  </div>
);

export default Widget;